/** biome-ignore-all lint/style/noMagicNumbers: TODO: fix */
import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import '../../../styles/savers/select-search.css';

import { useNavigate } from 'react-router-dom';
import { Button, Card, Col, Progress as CustomProgress, Form, Row, Tooltip } from 'antd';
import { uniqBy } from 'es-toolkit';
import moment from 'moment';

import { APP_ROUTES } from '@/contants/routes';
import { getLocalDateTime, getLocalTimeZone } from '@/utils/date';
import WarningModal from '@/views/components/Modals/WarningModal';
import ToggleSwitch from '@/views/components/Switch/ToggleSwitch';
import TMSFiledCard from '@/views/screens/common/components/TMSFiledCard';
import { calculateLinearFeet, getTrailerLabel } from '@/views/screens/Savers/utils';

import { setAppLoader } from '../../../redux/common/CommonActions';
import { setTrailerRequestId } from '../../../redux/Savers/SaversActions';
import {
  getAllFreightCommodityIdEffect,
  getBranchesByCustomerEffect,
  getTrailerDetailsEffect,
  getTrailerRequestByIDEffect,
  getTrailerRequestStatusEffect,
  getTrailersListEffect,
  getUnitSizesEffect,
  getUserRelationEffect,
  getUserTypeEffect,
  saveTrailerRequest,
} from '../../../redux/Savers/SaversEffects';
import { getFormattedTimeString } from '../../../utilz';
import FormDatePicker from '../../components/Inputs/FormDatePicker';
import FormInput from '../../components/Inputs/FormInput';
import FormSelectBox from '../../components/Inputs/FormSelectBox';
import FormTextArea from '../../components/Inputs/FormTextArea';
import SecondaryLabel from '../../components/Labels/SecondaryLabel';
import AlertModal from '../../components/Modals/AlertModal';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import Paper from '../../components/Paper/Paper';
import { PICKUP_TIME_OPTIONS } from './shipment/constants';
import ProductTypes from './TrailerRequests/ProductTypes';
import { DEFAULT_PAGE_NUMBER, SUPPLIER_REGION_KEYS } from './trailer-request.constants';

const deliveryTimeOptions = [
  {
    label: '8 AM to 12 P.M',
    value: '8 AM to 12 P.M',
  },
  {
    label: '12 PM to 4 P.M',
    value: '12 PM to 4 P.M',
  },
];

const DEFAULT_PAGE_SIZE = 500;

export default function TrailerReview() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.auth.selectedCompany.companyId, shallowEqual);
  const requestID = useSelector((state) => state.savers.reqID.data);
  const userRole = useSelector((state) => state.savers.loggedInUser.data);
  const currentDate = getLocalDateTime();

  const [formUpdateTrailerRequest] = Form.useForm();

  const [pTimeToCheck, setPTimeToCheck] = useState('');

  const [requestType, setRequestType] = useState('');
  const [nameLabel, setNameLabel] = useState('Team Member Name');
  const [locationLabel, setLocationLabel] = useState('Team Member Location ID');
  const [addressLabel, setAddressLabel] = useState('Team Member Address');
  const [phoneLabel, setPhoneLabel] = useState('Team Member Phone #');
  const [trlHidden, setTrlHidden] = useState(false);

  const [pickupDateLabel, setPickupDateLabel] = useState('Pickup Date');
  const [pickupTimeLabel, setPickupTimeLabel] = useState('Pickup Time');

  const [selectedValue, setSelectedValue] = useState('');

  const [selectedTrailerPickValue, setSelectedTrailerPickValue] = useState('');
  const [selectedTrailerDoorValue, setSelectedTrailerDoorValue] = useState('');
  const [selectedLoadValue, setSelectedLoadValue] = useState('');

  const [partnerLocationOptions, setPartnerLocationOptions] = useState([]);
  const [trailerOptions, setTrailerOptions] = useState([]);
  const [trailerSizeOptions, setTrailerSizeOptions] = useState([]);
  const [commodityOptions, setCommodityOptions] = useState([]);
  const [trailerRequestStatusOptions, setTrailerRequestStatusOptions] = useState([]);
  const [trafficCoordinatorOptions, setTrafficCoordinatorOptions] = useState([]);

  const [hidden, setHidden] = useState(true);
  const [checked, setChecked] = useState(false);

  const [trailerReqID, setTrailerReqID] = useState(0);
  const [trailerID, setTrailerID] = useState(0);
  const [trailerName, setTrailerName] = useState('');
  const [locationID, setLocationID] = useState(0);
  const [pickupTrailerSize, setPickupTrailerSize] = useState('');
  const [trailerConditionStatusID, setTrailerConditionStatusID] = useState('');
  const [trailerRequestDate, setTrailerRequestDate] = useState('');
  const [trailerRequestTimeframe, setTrailerRequestTimeframe] = useState('');
  const [trafficCoordinatorID, setTrafficCoordinatorID] = useState(null);
  const [trailerRequestStatusID, setTrailerRequestStatusID] = useState('');
  const [trailerRequestStatusDesc, setTrailerRequestStatusDesc] = useState('');
  const [isLoadedPickUp, setIsLoadedPickUp] = useState(false);
  const [isEmptyPickUp, setIsEmptyPickUp] = useState(false);
  const [productType, setProductType] = useState('');
  const [sealNumber, setSealNumber] = useState(0);
  const [productTypeDesc, setProductTypeDesc] = useState('');
  const [deliveryproductType, setdeliveryProductType] = useState('');
  const [deliveryproductTypeDesc, setdeliveryProductTypeDesc] = useState('');
  const [deliveryDate, setDeliveryDate] = useState('');
  const [deliveryTime, setDeliveryTime] = useState('');
  const [isEmptyDelivered, setIsEmptyDelivered] = useState(false);
  const [isLoadedDelivered, setIsLoadedDelivered] = useState(false);
  const [isMultiStop, setIsMultiStop] = useState(false);
  const [trailerDoorType, setTrailerDoorType] = useState('');
  const [isLiveLoad, setIsLiveLoad] = useState(false);
  const [estimatedWeight, setEstimatedWeight] = useState(0);
  const [estimatedDimension, setEstimatedDimension] = useState(0);
  const [specialInstruction, setSpecialInstruction] = useState('');
  const [deliveryestimatedWeight, setdeliveryEstimatedWeight] = useState(0);
  const [deliveryestimatedDimension, setdeliveryEstimatedDimension] = useState(0);

  const [newSuccessAlert, setNewSuccessAlert] = useState(false);
  const successMessage = 'Do you want to save the recent changes made to the request?';

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [fullName, setFullName] = useState('');

  const [branchKey, setBranchKey] = useState(0);
  const [branchAddr1, setBranchAddr1] = useState('');
  const [branchBusPhone, setBranchBusPhone] = useState('');
  const [rscm, setRSCM] = useState('');
  const [scs, setSCS] = useState('');
  const [requester, setRequester] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [requesterType, setRequesterType] = useState('');

  const [branchAddr2, setBranchAddr2] = useState('');
  const [branchCity, setBranchCity] = useState('');
  const [branchState, setBranchState] = useState('');
  const [branchPostal, setBranchPostal] = useState('');
  const [branchCustRef, setBranchCustRef] = useState('');

  const [trailerRequestData, setTrailerRequestData] = useState([]);
  const [stop1, setStop1] = useState(0);
  const [stop2, setStop2] = useState(0);
  const [stop3, setStop3] = useState(0);

  const [trailerRequestLocation, setTrailerRequestLocation] = useState('');
  const [stopDesc2, setStopDesc2] = useState('');
  const [disableFlag, setDisableFlag] = useState(false);
  const [proceedType, setProceedType] = useState('save');
  const [requestCondition, setRequestCondition] = useState('');

  const [liveLoadHoursOptions] = useState([
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
  ]);

  const [liveLoadHours, setLiveLoadHours] = useState(0);
  const [warningModal, setWarningModal] = useState(false);
  const [warning, setWarning] = useState('');
  const [requestUserType, setRequestUserType] = useState('');
  const [matchesDDP, setMatchesDDP] = useState(false);
  const [expDeliveryDate, setExpDeliveryDate] = useState(null);
  const [expDeliveryTime, setExpDeliveryTime] = useState(null);
  const [comments, setComments] = useState(null);
  const [branchContact, setBranchContact] = useState(null);
  const [productTypeName, setProductTypeName] = useState('');
  const [percentage, setPercentage] = useState(0);
  const [tableData, setTableData] = useState([]);

  const onConfirmFunc = () => {
    setNewSuccessAlert(false);
  };

  const validateEstWeight = () => {
    if (selectedTrailerPickValue === 'Loaded' && requesterType !== 'Supplier') {
      const hasInvalidWeight = tableData.some((item) => {
        const weight = item.estWeight;
        return weight === '' || weight === 0 || weight === null;
      });

      if (hasInvalidWeight) {
        setAlertOpen(true);
        setAlertMessage(
          tableData.length > 1 ? 'Estimated weight is required for all products' : 'Estimated weight is required',
        );
        return false;
      }
      return true;
    }
    return true;
  };
  const onProceed = (type) => {
    if (
      validateLoaded() &&
      validateTrailer() &&
      requiredPickUpdate() &&
      validateCommodity() &&
      validateDelCommodity() &&
      validateStop() &&
      validateTrafficCoordinator() &&
      validateDeliveryTimeRange() &&
      validateSpecialInstruction() &&
      validatePickupTimeframe() &&
      validateEstWeight()
    ) {
      if (type === 'proceed') {
        setProceedType(type);
        saveTrailerRequestData(type);
      } else {
        setNewSuccessAlert(true);
        setProceedType(type);
      }
    }
  };

  useEffect(() => {
    if (
      requestCondition &&
      (requestCondition === 'ACK' ||
        requestCondition === 'ACK ' ||
        requestCondition === 'CNF' ||
        requestCondition === 'CNF ')
    ) {
      setDisableFlag(true);
    }
  }, [requestCondition]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: unwanted dependency
  useEffect(() => {
    getTrailerList();
    getTrailerSizes();
    getTrailerCommodities();
    getTrailerRequestStatus();
    getUserRelations();
    getTrafficCoordinator();
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: unwanted dependency
  useEffect(() => {
    if (companyId && companyId !== 0 && companyId !== '0') {
      getPartnerLocations(companyId);
    }
  }, [companyId]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: unwanted dependency
  useEffect(() => {
    if (requestID && requestID !== 0 && requestID !== '0') {
      getTrailerRequestData(requestID);
    }
  }, [requestID]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: unwanted dependency
  useEffect(() => {
    if (trailerRequestData && trailerRequestData.length > 0) {
      const request = trailerRequestData?.[0]?.trailerRequestData?.[0] ?? {};
      dispatch(setAppLoader(true));
      setRequestType(request.requestType);
      setTrailerReqID(request.trailerRequestID);
      setLocationID(request.locationID);
      setTrailerRequestLocation(request.branchDesc);
      setTrailerID(request.trailerID);
      setTrailerName(request.trailerNumber);
      setTrailerConditionStatusID(request.trailerConditionStatusID);
      setTrailerRequestDate(request.trailerRequestDate);
      setPTimeToCheck(moment(request.deliveryDate).format('HH:mm'));
      setTrafficCoordinatorID(request.trafficCoordinatorID);
      setTrailerRequestStatusID(request.trailerRequestStautsID);
      setTrailerRequestStatusDesc(request.trailerRequestStatusDesc);
      setIsLoadedPickUp(request.isLoadedPickUp);
      if (request.isLoadedPickUp === true) {
        setChecked(true);
        setSelectedTrailerPickValue('Loaded');
        setPickupDateLabel('Date Trailer Loaded');
        setPickupTimeLabel('Time Trailer Loaded');
      } else {
        if (request.isEmptyPickUp === true) {
          setChecked(false);
          setSelectedTrailerPickValue('Empty');
          setPickupDateLabel('Date Trailer Emptied');
          setPickupTimeLabel('Time Trailer Emptied');
        } else {
          setChecked(false);
          setSelectedTrailerPickValue('None');
          setPickupDateLabel('Pickup Date');
          setPickupTimeLabel('Pickup Time');
        }
      }

      setIsEmptyPickUp(request.isEmptyPickUp);
      setProductType(request.productType);
      setProductTypeDesc(request.productTypeDesc);
      setProductTypeName(request.productTypeDesc);
      setEstimatedWeight(request.estimatedWeight);
      setEstimatedDimension(request.estimatedDimension);
      setdeliveryProductType(request.deliveryProductType);
      setdeliveryProductTypeDesc(request.deliveryProductTypeDesc);
      setdeliveryEstimatedWeight(request.deliveryEstimatedWeight);
      setdeliveryEstimatedDimension(request.deliveryEstimatedDimension);
      setDeliveryDate(request.deliveryDate);
      setDeliveryTime(request.deliveryTimeFrame);
      setIsEmptyDelivered(request.isEmptyDelivered);
      setIsLoadedDelivered(request.isLoadedDelivered);
      setComments(request.comments);
      setExpDeliveryDate(request.expDeliveryDate);
      setExpDeliveryTime(request.expDeliveryTime);
      setMatchesDDP(request.matchesDDP);
      if (request.isLoadedDelivered === true) {
        setSelectedValue('Loaded');
      } else {
        if (request.isEmptyDelivered === true) {
          setSelectedValue('Empty');
        } else {
          setSelectedValue('None');
        }
      }
      setIsMultiStop(request.isMultiStop);
      setTrailerDoorType(request.trailerDoorType);
      if (request.trailerDoorType === 'SWNGDR') {
        setSelectedTrailerDoorValue('Swingdoor');
      } else if (request.trailerDoorType === 'RLLUPDR') {
        setSelectedTrailerDoorValue('RollUpdoor');
      } else if (request.trailerDoorType === 'SLDNGDR') {
        setSelectedTrailerDoorValue('Slidingdoor');
      } else if (request.trailerDoorType === 'FLDNGDR') {
        setSelectedTrailerDoorValue('Foldingdoor');
      } else if (request.trailerDoorType === 'HNGDR') {
        setSelectedTrailerDoorValue('Hingeddoor');
      }
      setIsLiveLoad(request.isLiveLoad);
      if (request.isLiveLoad === true) {
        setSelectedLoadValue('Load');
      } else {
        setSelectedLoadValue('UnLoad');
      }
      if (request?.liveLoadHours) {
        setLiveLoadHours(request?.liveLoadHours);
      }
      setSpecialInstruction(request.specialInstruction);
      setFullName(request.fullName);
      setBranchKey(request.branchCustRef);
      setRSCM(request.rscm);
      setSCS(request.scs);
      setBranchAddr1(request.branchAddr1);
      setBranchAddr2('');
      setBranchCity(request.branchCity);
      setBranchState(request.branchStateName);
      setBranchPostal(request.branchZip);
      setBranchCustRef(request.branchCustRef);
      setBranchBusPhone(request.branchBusPhone);
      setPhoneNumber(request.requesterPhone);
      setRequester(request.requesterName);
      if (request.supplierNumber) {
        if (request.supplierNumber !== null && request.supplierNumber !== '') {
          setRequesterType('Supplier');
        } else {
          setRequesterType('');
        }
      }
      if (trailerRequestData[0].trailerRequestStopDetailsData.length > 0) {
        if (trailerRequestData[0].trailerRequestStopDetailsData.length === 1) {
          setStop1(trailerRequestData[0].trailerRequestStopDetailsData[0].locationID);
        } else if (trailerRequestData[0].trailerRequestStopDetailsData.length === 2) {
          setStop1(trailerRequestData[0].trailerRequestStopDetailsData[0].locationID);
          setStop2(trailerRequestData[0].trailerRequestStopDetailsData[1].locationID);
          setStopDesc2(trailerRequestData[0].trailerRequestStopDetailsData[1].branchDesc);
        } else if (trailerRequestData[0].trailerRequestStopDetailsData.length === 3) {
          setStop1(trailerRequestData[0].trailerRequestStopDetailsData[0].locationID);
          setStop2(trailerRequestData[0].trailerRequestStopDetailsData[1].locationID);
          setStopDesc2(trailerRequestData[0].trailerRequestStopDetailsData[1].branchDesc);
          setStop3(trailerRequestData[0].trailerRequestStopDetailsData[2].locationID);
        }
      }

      if (request?.liveLoadHours) {
        formUpdateTrailerRequest.setFieldsValue({
          LiveLoadHours: request?.liveLoadHours,
        });
      }
      const trailerData = trailerRequestData[0]?.trailerRequestData[0] || {};
      const productDataArray = trailerRequestData[0]?.trailerRequestProductData;
      if (productDataArray.length > 0) {
        const mixedProductTypes = productDataArray.map((res, index) => {
          const option = commodityOptions.find((o) => o.value.toString() === res.productType.toString());

          return {
            estDimension: res.estimatedDimension,
            estWeight: res.estimatedWeight,
            key: index + 1,
            productType: res.productType,
            productTypeLabel: option?.label || '',
          };
        });
        setTableData(mixedProductTypes);
        const formObj = {};
        mixedProductTypes.forEach((row) => {
          formObj[`productType${row.key}`] = row.productTypeLabel;
        });
        formUpdateTrailerRequest.setFieldsValue(formObj);
      } else {
        const singleProduct = [
          {
            estDimension: trailerData.estimatedDimension,
            estWeight: trailerData.estimatedWeight,
            key: 1,
            productType: trailerData.productType,
            productTypeLabel:
              commodityOptions.find((o) => o.value.toString() === trailerData.productType.toString())?.label || '',
          },
        ];
        setTableData(singleProduct);
      }

      formUpdateTrailerRequest.setFieldsValue({
        ConditionStatus: trailerData.trailerConditionStatusID,
        comments: trailerData.comments,
        deliveryDate: trailerData.deliveryDate ? moment(trailerData.deliveryDate) : null,
        deliveryLocation: requesterType === 'Store' ? trailerData?.branchDesc : trailerData?.branchCustRef,
        expDeliveryDate: trailerData.expDeliveryDate ? moment(trailerData.expDeliveryDate) : null,
        expDeliveryTime: trailerData.expDeliveryTime,
        matchesDDP: trailerData.matchesDDP,
        PartnerLocation: trailerData.branchDesc,
        pickupLocation: requesterType === 'Store' ? trailerData?.branchDesc : trailerData?.branchCustRef,
        sealNumber: trailerData.sealNumber,
        selCommodity: trailerData.productType && Number.parseInt(trailerData.productType, 10),
        selCommodity1: trailerData.deliveryProductType && Number.parseInt(trailerData.deliveryProductType, 10),
        selectDeliveryTime: trailerData.deliveryTimeFrame,
        selRequestStatus: trailerData.trailerRequestStatusDesc,
        txtAddr1: trailerData.branchAddr1,
        txtDelLocation: trailerData.locationID,
        txtfullName: trailerData.fullName,
        txtPhone: trailerData.branchBusPhone,
        txtRSCM: trailerData.rscm,
        txtSCS: trailerData.scs,
        txtSpclInstruct: trailerData.specialInstruction,
      });
      setBranchContact(trailerData.branchContact);
      setSealNumber(trailerData.sealNumber);
      if (trailerData?.isLoadedPickUp || trailerData?.isEmptyPickUp) {
        setTrailerRequestTimeframe(trailerData?.requestTimeFrame || '');
        formUpdateTrailerRequest.setFieldsValue({
          selectPickupTime: trailerData?.requestTimeFrame,
          trailerDate: trailerData.trailerRequestDate ? moment(trailerData.trailerRequestDate) : null,
        });
      }
      if (trailerData.trailerNumber) {
        formUpdateTrailerRequest.setFieldsValue({
          selTrailerName: trailerData.trailerNumber,
        });
      }
      if (request.trailerID && request.trailerID !== 0 && request.trailerID !== '0') {
        if (request.pickupTrailerSize || trailerData.pickupTrailerSize) {
          const initialSizeValue = request.pickupTrailerSize || trailerData.pickupTrailerSize;
          if (initialSizeValue) {
            formUpdateTrailerRequest.setFieldsValue({
              trailerSize: Number(initialSizeValue),
            });
            setPickupTrailerSize(initialSizeValue);
          }
        }
        getTrailerDetailsData(request.trailerID);
      } else if (trailerData.pickupTrailerSize) {
        formUpdateTrailerRequest.setFieldsValue({
          trailerSize: Number(trailerData.unitSize),
        });
        setPickupTrailerSize(request.pickupTrailerSize);
      }
      if (trailerData.trafficCoordinatorID) {
        formUpdateTrailerRequest.setFieldsValue({
          TrafficCoord: trailerData.trafficCoordinatorID,
        });
      }
      if (request.supplierNumber) {
        if (request.supplierNumber !== null && request.supplierNumber !== '') {
          formUpdateTrailerRequest.setFieldsValue({
            txtRequester: request?.requesterName,
          });
          formUpdateTrailerRequest.setFieldsValue({
            txtState: request?.branchStateName,
          });
          formUpdateTrailerRequest.setFieldsValue({
            txtCity: request?.branchCity,
          });
          formUpdateTrailerRequest.setFieldsValue({
            txtPostal: request?.branchZip,
          });
          formUpdateTrailerRequest.setFieldsValue({
            txtPhone: request?.requesterPhone,
          });
        }
      }

      if (trailerRequestData[0].trailerRequestStopDetailsData.length > 0) {
        if (trailerRequestData[0].trailerRequestStopDetailsData.length === 1) {
          formUpdateTrailerRequest.setFieldsValue({
            stop1: trailerRequestData[0].trailerRequestStopDetailsData[0]?.branchDesc,
          });
        } else if (trailerRequestData[0].trailerRequestStopDetailsData.length === 2) {
          formUpdateTrailerRequest.setFieldsValue({
            stop1: trailerRequestData[0].trailerRequestStopDetailsData[0]?.branchDesc,
          });
          formUpdateTrailerRequest.setFieldsValue({
            stop2: trailerRequestData[0].trailerRequestStopDetailsData[1]?.branchDesc,
          });
        } else if (trailerRequestData[0].trailerRequestStopDetailsData.length === 3) {
          formUpdateTrailerRequest.setFieldsValue({
            stop1: trailerRequestData[0].trailerRequestStopDetailsData[0]?.branchDesc,
          });
          formUpdateTrailerRequest.setFieldsValue({
            stop2: trailerRequestData[0].trailerRequestStopDetailsData[1]?.branchDesc,
          });
          formUpdateTrailerRequest.setFieldsValue({
            stop3: trailerRequestData[0].trailerRequestStopDetailsData[2]?.branchDesc,
          });
        }
      }
      dispatch(setAppLoader(false));
    }
  }, [trailerRequestData]);

  const getTrafficCoordinator = async () => {
    try {
      const { data } = await getUserTypeEffect('CT');
      const uniqueCoordinators = uniqBy(data, ({ userId }) => userId);
      const options = uniqueCoordinators.map((row) => ({
        label: row.fullName,
        value: row.userId,
      }));
      setTrafficCoordinatorOptions(options);
    } catch (error) {
      console.error(error);
      setTrafficCoordinatorOptions([]);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const getPartnerLocations = async (companyId) => {
    dispatch(setAppLoader(true));
    if (companyId !== undefined && companyId !== 0 && companyId !== '0' && companyId !== '') {
      try {
        // TODO: useGetShipmentVendorBranch hook
        const { data } = await getBranchesByCustomerEffect(companyId);
        const options = data.map((row) => ({
          label: SUPPLIER_REGION_KEYS.includes(row.regionKey)
            ? row.branchCustRef
            : `${row.branchDesc} - ${row.branchCustRef}`,
          value: row.branchKey,
        }));
        setPartnerLocationOptions(options);
      } catch (error) {
        console.error(error);
        setPartnerLocationOptions([]);
        console.error(branchKey);
      }
    }
  };

  const getTrailerRequestData = async (requestID) => {
    dispatch(setAppLoader(true));
    if (requestID !== undefined && requestID !== 0 && requestID !== '0' && requestID !== '') {
      try {
        const { data } = await getTrailerRequestByIDEffect(requestID);

        setTrailerRequestData(data);
        if (data.length > 0) {
          setRequestUserType(data[0].trailerRequestData[0].userType);
          setTrailerName(data[0].trailerRequestData[0].trailerNumber);

          setRequestCondition(data[0].trailerRequestData[0].trailerRequestStautsID);
        }
      } catch (error) {
        console.error(error);
        setTrailerRequestData([]);
      } finally {
        dispatch(setAppLoader(false));
      }
    }
  };
  const saveTrailerRequestData = async (type) => {
    dispatch(setAppLoader(true));
    const requestData = [];
    const isMixedProduct = Number(productType) === 5;
    const products =
      tableData.length > 0
        ? tableData.map((item) => ({
            estimatedDimension: Number(item.estDimension) || 0,
            estimatedWeight: Number(item.estWeight) || 0,
            productType: item.productType?.toString() || '',
          }))
        : [];
    try {
      requestData.push({
        comments,
        deliveryDate,
        deliveryEstimatedDimension: deliveryestimatedDimension,
        deliveryEstimatedWeight: deliveryestimatedWeight,
        deliveryProductType: deliveryproductType.toString(),
        deliveryTimeFrame: deliveryTime,
        estimatedDimension: products[0]?.estimatedDimension,
        estimatedWeight: products[0]?.estimatedWeight,
        expDeliveryDate,
        expDeliveryTime,
        isEmptyDelivered,
        isEmptyPickUp,
        isLiveLoad,
        isLoadedDelivered,
        isLoadedPickUp,
        isMixedProduct,
        isMultiStop,
        liveLoadHours,
        locationID,
        matchesDDP,
        pickupTrailerSize: pickupTrailerSize.toString(),
        products,
        productType: productType.toString(),
        requesterName: requester,
        requesterPhone: phoneNumber,
        requestType,
        requesttimeframe: trailerRequestTimeframe,
        sealNumber,
        specialInstruction,
        specialInstructionTrailerSize: '',
        stopOne: stop1,
        stopThree: stop3,
        stopTwo: stop2,
        supplierNumber: requesterType === 'Supplier' ? branchCustRef : '',
        trafficCoordinatorID,
        trailerConditionStatusID,
        trailerDoorType,
        trailerID,
        trailerRequestDate: trailerRequestDate === '' ? currentDate : trailerRequestDate,
        trailerRequestID: trailerReqID,
        trailerRequestStautsID: trailerRequestStatusID,
      });
      const { data } = await saveTrailerRequest(requestData[0]);
      if (data === 1) {
        setAlertMessage('Trailer Request Data Updated');
        setAlertOpen(false);
        setNewSuccessAlert(false);
        formUpdateTrailerRequest.resetFields();
        dispatch(setTrailerRequestId(trailerReqID));
        if (proceedType === 'proceed' || type === 'proceed') {
          navigate('/trailer-request-management', {
            state: {
              companyId,
              data: requestData,
              requestID: trailerReqID,
              requestUserType,
              userType: userRole,
            },
          });
        } else {
          navigate(APP_ROUTES.SAVERS);
          getTrailerRequestData(requestID);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const onAlertConfirm = () => {
    setAlertOpen(false);
  };
  const getTrailerList = async (branchKey) => {
    dispatch(setAppLoader(true));
    try {
      const params = {};
      if (branchKey && branchKey !== '0') {
        params.branchKey = branchKey;
      }
      if (requestUserType === 'CT' && branchContact === 'Y') {
        params.trailerMovementType = 'Outbound';
      }
      const { data } = await getTrailersListEffect({
        PageNumber: DEFAULT_PAGE_NUMBER,
        PageSize: DEFAULT_PAGE_SIZE,
        ...params,
      });

      const filteredTrailers = data.filter((trailer) => trailer.status !== '');
      const options = filteredTrailers.map((row) => ({
        label: row.trailerNumber,
        value: row.trailerID,
      }));
      setTrailerOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerOptions([]);
    }
  };

  const getTrailerDetailsData = async (trailerID) => {
    try {
      const { data } = await getTrailerDetailsEffect(trailerID);
      if (data.length > 0) {
        setTrailerConditionStatusID(data[0].trailerStatusID);
        formUpdateTrailerRequest.setFieldsValue({
          ConditionStatus: data[0].trailerStatusID,
        });
        if (data[0].unitSizeID) {
          formUpdateTrailerRequest.setFieldsValue({
            trailerSize: data[0].unitSizeID,
          });
          setPickupTrailerSize(data[0].unitSizeID);
        }
      }
    } catch (error) {
      console.error(error);
      setTrailerConditionStatusID('');
    }
  };

  const getTrailerSizes = async () => {
    try {
      const { data } = await getUnitSizesEffect();

      const options = data.map((row) => ({
        label: row.size,
        value: row.id,
      }));
      setTrailerSizeOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerSizeOptions([]);
    }
  };

  const getUserRelations = async () => {
    try {
      const { data } = await getUserRelationEffect();
      if (data.length > 0) {
        if (data[0].userType !== 'CT' && data[0].userType !== 'Store' && data[0].userType !== 'STORE') {
          setNameLabel('Supplier Name');
          setLocationLabel('Supplier Location ID');
          setAddressLabel('Supplier Address');
          setPhoneLabel('Supplier Phone #');
          setTrlHidden(true);
        }
      } else {
        setFullName('');
        setBranchKey(0);
        setLocationID(0);

        setBranchAddr1('');
        setBranchBusPhone('');
        setRSCM('');
        setSCS('');
        setNameLabel('Supplier Name');
        setLocationLabel('Supplier Location ID');
        setAddressLabel('Supplier Address');
        setPhoneLabel('Supplier Phone #');
        setTrlHidden(true);
      }
    } catch (error) {
      console.error(error);

      setFullName('');
      setBranchKey(0);
      setLocationID(0);

      setBranchAddr1('');
      setBranchBusPhone('');
      setRSCM('');
      setSCS('');
    }
  };

  const getTrailerCommodities = async () => {
    try {
      const { data } = await getAllFreightCommodityIdEffect();

      const options = data.map((row) => ({
        label: row.freightCommodity,
        value: row.freightCommodityID,
      }));
      setCommodityOptions(options);
    } catch (error) {
      console.error(error);
      setCommodityOptions([]);
    }
  };

  const getTrailerRequestStatus = async () => {
    try {
      const { data } = await getTrailerRequestStatusEffect();

      const options = data.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      }));
      setTrailerRequestStatusOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerRequestStatusOptions([]);
    }
  };

  const selectLocationID = (e) => {
    setLocationID(e.value);
    setBranchKey(e.value);
  };

  const selectTrailerRequestStatus = (e) => {
    setTrailerRequestStatusID(e.value);
  };
  const selectTrafficCoordinatorId = (e) => {
    setTrafficCoordinatorID(e.value);
  };
  const selectTrailerName = (e) => {
    if (!e || !e.value || e.value === 0 || e.value === '0') {
      setTrailerID(0);
      setTrailerName('');
      setPickupTrailerSize('');
      setTrailerConditionStatusID('');
      formUpdateTrailerRequest.setFieldsValue({
        ConditionStatus: null,
        selTrailerName: null,
        trailerSize: null,
      });
    } else {
      setTrailerID(e.value);
      setTrailerName(e.label);
      getTrailerDetailsData(e.value);
    }
  };
  const selectTrailerSize = (e) => {
    setPickupTrailerSize(e.value);
  };
  const selectRequestDate = (e) => {
    let trailerreqdate = moment(e).format().substring(0, 10);
    if (pTimeToCheck) {
      const newDate = `${trailerreqdate} ${pTimeToCheck}`;
      const date = new Date(newDate);
      trailerreqdate = getFormattedTimeString(date);
    }
    validatePickupDate(trailerreqdate);
    setTrailerRequestDate(trailerreqdate);
  };

  const selectRequestTimeframe = (e) => {
    const value = e?.value ?? null;
    setTrailerRequestTimeframe(value);
  };

  const setRequesterName = (e) => {
    setRequester(e.currentTarget.value);
  };
  const setSupplierPhone = (e) => {
    setPhoneNumber(e.currentTarget.value);
  };
  const selectCommodity = (e) => {
    setProductType(e.value);
    setProductTypeName(e.label);
    setEstimatedDimension(calculateLinearFeet(estimatedWeight, e.value));
    if (Number(e.value) !== 5) {
      setTableData([
        {
          estDimension: '',
          estWeight: '',
          key: 1,
          productType: e.value,
        },
      ]);
    }
  };
  const selectSealNumber = (e) => {
    setSealNumber(e.currentTarget.value);
  };
  const selectdeliveryCommodity = (e) => {
    setdeliveryProductType(e.value);
    setdeliveryProductTypeDesc(e.label);
  };
  const selectDeliveryDate = (e) => {
    const trailerdeldate = moment(e).format().substring(0, 10);
    validateDeliverydate(trailerdeldate);
    setDeliveryDate(trailerdeldate);
  };
  const selectDeliveryTime = (e) => {
    setDeliveryTime(e.value);
  };

  const selectDelivered = (e) => {
    let reqType = '';
    formUpdateTrailerRequest.resetFields(['deliveryDate', 'selectDeliveryTime', 'selCommodity1']);
    setDeliveryDate(null);
    setdeliveryProductTypeDesc('');
    if (e.currentTarget.id === 'Empty') {
      setIsEmptyDelivered(true);
      setIsLoadedDelivered(false);
      setSelectedValue('Empty');
      reqType = 'Empty';
    } else if (e.currentTarget.id === 'Loaded') {
      setIsEmptyDelivered(false);
      setIsLoadedDelivered(true);
      setSelectedValue('Loaded');
      reqType = 'Loaded';
    } else if (e.currentTarget.id === 'None') {
      setIsEmptyDelivered(false);
      setIsLoadedDelivered(false);
      setSelectedValue('None');
      reqType = 'None';
    }
    if (selectedTrailerPickValue === '' && reqType !== '') {
      setRequestType('Outbound');
    } else if (selectedTrailerPickValue !== '' && reqType !== '') {
      setRequestType('Return');
    }
  };

  const closeModal = () => {
    setHidden(!hidden);
  };
  const setLiveLoadUnloadHour = (e) => {
    if (e) {
      setLiveLoadHours(e.value);
    } else {
      setLiveLoadHours(0);
    }
  };
  const shouldToggleChecked = (e) => {
    dispatch(setAppLoader(true));
    let reqType = '';
    setChecked(!checked);
    formUpdateTrailerRequest.resetFields([
      'selTrailerName',
      'trailerSize',
      'trailerDate',
      'selectPickupTime',
      'selCommodity',
    ]);
    setPickupTrailerSize('');
    setTrailerRequestDate('');
    setProductTypeDesc('');
    if (e.currentTarget.id === 'pickEmpty') {
      setIsEmptyPickUp(true);
      setIsLoadedPickUp(false);
      setSelectedTrailerPickValue('Empty');
      reqType = 'Empty';
      setPickupDateLabel('Date Trailer Emptied');
      setPickupTimeLabel('Time Trailer Emptied');
      if (userRole !== 'CT') {
        getTrailerList(branchKey, 'EMT');
      } else {
        getTrailerList('', 'EMT');
      }
    } else if (e.currentTarget.id === 'pickLoaded') {
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(true);
      setSelectedTrailerPickValue('Loaded');
      reqType = 'Loaded';
      setPickupDateLabel('Date Trailer Loaded');
      setPickupTimeLabel('Time Trailer Loaded');
      if (userRole !== 'CT') {
        getTrailerList(branchKey, 'LOD');
      } else {
        getTrailerList('', 'LOD');
      }
    } else if (e.currentTarget.id === 'pickNone') {
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(false);
      setSelectedTrailerPickValue('None');
      reqType = 'None';
      setPickupDateLabel('Pickup Date');
      setPickupTimeLabel('Pickup Time');
      setTrailerOptions([]);
    }

    if (reqType !== '' && reqType !== 'None' && (selectedValue === '' || selectedValue === 'None')) {
      setRequestType('Inbound');
    } else if (reqType !== '' && reqType !== 'None' && selectedValue !== '' && selectedValue !== 'None') {
      setRequestType('Round');
    } else if (reqType === 'None' && selectedValue === 'None') {
      setRequestType('');
      setAlertOpen(true);
      setAlertMessage('Please provide instruction.');
    } else if (reqType === 'None' && selectedValue === '') {
      setRequestType('');
    } else if (selectedValue !== 'None' && selectedValue !== '' && reqType === 'None') {
      setRequestType('Outbound');
    }
    dispatch(setAppLoader(false));
  };
  const selectDoorType = (e) => {
    const { id, value } = e.currentTarget;
    if (selectedTrailerDoorValue === id) {
      setSelectedTrailerDoorValue('');
      setTrailerDoorType('');
      setSelectedLoadValue('Unload');
      setIsLiveLoad(false);
      return;
    }
    setTrailerDoorType(value);
    setSelectedLoadValue('Load');
    setIsLiveLoad(true);
    if (id === 'Swingdoor') {
      setSelectedTrailerDoorValue(id);
    } else if (id === 'RollUpdoor') {
      setSelectedTrailerDoorValue(id);
    } else if (id === 'Slidingdoor') {
      setSelectedTrailerDoorValue(id);
    } else if (id === 'Foldingdoor') {
      setSelectedTrailerDoorValue(id);
    } else if (id === 'Hingeddoor') {
      setSelectedTrailerDoorValue(id);
    }
  };

  const selectLiveLoad = (e) => {
    if (e.currentTarget.value === 'Yes') {
      setIsLiveLoad(true);
      setSelectedLoadValue('Load');
    } else if (e.currentTarget.value === 'No') {
      setIsLiveLoad(false);
      setSelectedLoadValue('UnLoad');
      formUpdateTrailerRequest.setFieldValue('LiveLoadHours', '');
    }
  };
  const selectSpecialInstruction = (e) => {
    setSpecialInstruction(e.currentTarget.value);
  };

  const validateSpecialInstruction = () => {
    const needsInstruction = Number(deliveryproductType) === 5 && selectedValue === 'Loaded';
    if (needsInstruction && !specialInstruction) {
      setAlertOpen(true);
      setAlertMessage('Special instruction is required for mixed loaded goods.');
      return false;
    }
    return true;
  };

  const validateLoaded = () => {
    if (
      (!selectedTrailerPickValue && !selectedValue) ||
      (selectedTrailerPickValue === 'None' && selectedValue === 'None')
    ) {
      setAlertOpen(true);
      setAlertMessage('Please choose Pickup-Delivery option');
      return false;
    }

    return true;
  };

  const validateTrailer = () => {
    if (userRole !== 'Store') {
      return true;
    }

    if (selectedTrailerPickValue === 'Empty' || selectedTrailerPickValue === 'Loaded') {
      if (trailerID === 0) {
        setAlertOpen(true);
        setAlertMessage('Select Trailer');
        return false;
      }
      return true;
    }

    return true;
  };

  const validateCommodity = () => {
    if (selectedTrailerPickValue !== 'Loaded') {
      if (document.getElementById('errorCommodity') !== null) {
      }
      return true;
    }

    if (productType !== '' && productType !== undefined) {
      if (document.getElementById('errorCommodity') !== null) {
      }
      return true;
    }

    setAlertOpen(true);
    setAlertMessage('Select commodity');
    return false;
  };

  const validateDeliverydate = (deliveryDate) => {
    if (selectedValue === 'Loaded' || selectedValue === 'Empty') {
      const minDate = moment.tz(getLocalTimeZone()).add(3, 'days').startOf('day');
      const selectedDate = moment(deliveryDate, 'YYYY-MM-DD');

      if (selectedDate.isValid() && selectedDate.isSameOrAfter(minDate)) {
        return true;
      }
      setWarningModal(true);
      setWarning(
        'The requested date is not within 72 hours.  The traffic team will make every effort to meet your requested timeline',
      );
      return true;
    }
  };

  const validatePickupDate = (pickupDate) => {
    if (selectedTrailerPickValue === 'Loaded' || selectedTrailerPickValue === 'Empty') {
      const minDate = moment.tz(getLocalTimeZone()).add(3, 'days').startOf('day');
      const selectedDate = moment(pickupDate, 'YYYY-MM-DD');

      if (selectedDate.isValid() && selectedDate.isSameOrAfter(minDate)) {
        return true;
      }
      setWarningModal(true);
      setWarning(
        'The requested pickup date is not within 72 hours. The traffic team will make every effort to meet your requested timeline',
      );
      return true;
    }
  };

  const validatePickupTimeframe = () => {
    if (selectedTrailerPickValue === 'Loaded' || selectedTrailerPickValue === 'Empty') {
      const formValue = formUpdateTrailerRequest.getFieldValue('selectPickupTime');
      const hasValue = trailerRequestTimeframe || formValue;
      if (hasValue) {
        return true;
      }
      setAlertOpen(true);
      setAlertMessage(`Please select ${pickupTimeLabel.toLowerCase()}`);
      return false;
    }
    return true;
  };

  const validateDeliveryTimeRange = () => {
    if (selectedValue === 'Loaded' || selectedValue === 'Empty') {
      if (deliveryTime) {
        return true;
      }
      setAlertOpen(true);
      setAlertMessage('Please select delivery time between 8 AM and 4 PM');
      return false;
    }
    return true;
  };

  const requiredPickUpdate = () => {
    if (selectedTrailerPickValue === 'Loaded' || selectedTrailerPickValue === 'Empty') {
      if (trailerRequestDate) {
        return true;
      }
      setAlertOpen(true);
      setAlertMessage('Pickup date required');
      return false;
    }
    return true;
  };
  const validateTrafficCoordinator = () => {
    if (userRole === 'CT') {
      if (trafficCoordinatorID !== 0) {
        return true;
      }
      setAlertOpen(true);
      setAlertMessage('Select Traffic Coordinator');
      return false;
    }
    return true;
  };

  const validateStop = () => {
    if (isMultiStop === false) {
      return true;
    }

    if (stop1 !== 0 && stop1 !== '0') {
      return true;
    }

    setAlertOpen(true);
    setAlertMessage('Select stop1 location');
    return false;
  };

  const validateDelCommodity = () => {
    if (selectedValue !== 'Loaded') {
      return true;
    }

    if (deliveryproductType !== '' && deliveryproductType !== undefined) {
      return true;
    }

    setAlertOpen(true);
    setAlertMessage('Select delivery commodity');
    return false;
  };

  const trailerSize = formUpdateTrailerRequest.getFieldValue('trailerSize') || 0;

  const trailerValue = getTrailerLabel(trailerSize, trailerSizeOptions);

  const percentages =
    trailerValue > 0 && estimatedDimension >= 0 ? Math.min((estimatedDimension / trailerValue) * 100, 100) : 0;
  const getProgressBarColor = (percentages) => {
    if (percentages <= 90) {
      return 'red';
    }
    if (percentages <= 95) {
      return 'yellow';
    }
    return 'green';
  };

  const progressBarColor = getProgressBarColor(percentages);

  const handleMatchesDDPChange = (e) => {
    setMatchesDDP(e);
  };

  const handleExpDeliveryDateChange = (e) => {
    const expectedDeliveryDate = moment(e).format().substring(0, 10);
    setExpDeliveryDate(expectedDeliveryDate);
  };

  const handleExpDeliveryTimeChange = (e) => {
    setExpDeliveryTime(e.value);
  };

  const handleCommentsChange = (e) => {
    setComments(e.target.value);
  };

  const isMixed = productType === 5;
  return (
    <>
      <Row gutter={20}>
        <Col sm={24}>
          <span className="pull-right color-1">
            {' '}
            <strong> {userRole} </strong> Logged In{' '}
          </span>
        </Col>
      </Row>
      <div className="h-100 pb-15">
        <Row className="flex-direction-column flex-nowrap  h-100 ">
          <Col className="flex-1 custom-scroll-bar">
            <Form form={formUpdateTrailerRequest}>
              <div className="pb-5">
                <Paper className="mb-10">
                  <div className="p-10">
                    <Row gutter={15}>
                      <Col sm={4} className="px-10" style={{ borderRight: '5px solid #00557d26' }}>
                        <div className="fw-bold text-center mb-2">
                          <u>
                            <label htmlFor="">Requester Details</label>
                          </u>
                        </div>

                        <Row gutter={15}>
                          <Col sm={24}>
                            <FormInput
                              inputType="text"
                              name="txtfullName"
                              label={nameLabel}
                              margin="m-0"
                              editMode
                              defaultValue={fullName}
                              placeholder="Auto populated value"
                              readOnly
                              disabled={userRole !== 'CT'}
                            />
                          </Col>

                          <Col sm={24}>
                            {requesterType !== 'Supplier' && (
                              <FormInput
                                name="txtSCS"
                                label="SCS"
                                margin="m-0"
                                editMode
                                defaultValue={scs}
                                placeholder="Auto populated value"
                                readOnly
                                disabled={userRole !== 'CT'}
                              />
                            )}
                            {requesterType === 'Supplier' && (
                              <FormInput
                                name="txtRequester"
                                label="Requester Name"
                                margin="m-0"
                                editMode
                                value={requester}
                                placeholder="Requester Name"
                                defaultValue={requester}
                                onChange={setRequesterName}
                                disabled={userRole !== 'CT'}
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            {requesterType !== 'Supplier' && (
                              <FormInput
                                name="txtRSCM"
                                label="RSCM"
                                margin="m-0"
                                editMode
                                defaultValue={rscm}
                                placeholder="Auto populated value"
                                readOnly
                                disabled={userRole !== 'CT'}
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            <FormSelectBox
                              label={locationLabel}
                              editMode
                              name="PartnerLocation"
                              margin="m-0"
                              options={partnerLocationOptions}
                              placeholder="Select Partner Location"
                              onChange={selectLocationID}
                              defaultValue={trailerRequestLocation}
                              value={locationID}
                              disabled
                            />
                          </Col>

                          <Col sm={24}>
                            <FormInput
                              name="txtAddr1"
                              label={addressLabel}
                              margin="m-0"
                              editMode
                              defaultValue={branchAddr1}
                              placeholder="Auto populated value"
                              readOnly
                              disabled={userRole !== 'CT'}
                            />
                          </Col>
                          {requesterType === 'Supplier' && (
                            <Col sm={24}>
                              <FormInput
                                name="txtAddr2"
                                label="Supplier Address2"
                                margin="m-0"
                                editMode
                                value={branchAddr2}
                                placeholder="Supplier Address2"
                                defaultValue={branchAddr2}
                                readOnly
                                disabled={userRole !== 'CT'}
                              />
                            </Col>
                          )}

                          {requesterType === 'Supplier' && (
                            <Col sm={24}>
                              <FormInput
                                name="txtState"
                                label="Supplier State"
                                margin="m-0"
                                editMode
                                value={branchState}
                                placeholder="Supplier State"
                                defaultValue={branchState}
                                readOnly
                                disabled={userRole !== 'CT'}
                              />
                            </Col>
                          )}
                          {requesterType === 'Supplier' && (
                            <Col sm={24}>
                              <FormInput
                                name="txtCity"
                                label="Supplier City"
                                margin="m-0"
                                editMode
                                value={branchCity}
                                placeholder="Supplier City"
                                defaultValue={branchCity}
                                readOnly
                                disabled={userRole !== 'CT'}
                              />
                            </Col>
                          )}
                          {requesterType === 'Supplier' && (
                            <Col sm={24}>
                              <FormInput
                                name="txtPostal"
                                label="Supplier Zip"
                                margin="m-0"
                                editMode
                                value={branchPostal}
                                placeholder="Supplier Zip"
                                defaultValue={branchPostal}
                                readOnly
                                disabled={userRole !== 'CT'}
                              />
                            </Col>
                          )}
                          <Col sm={24}>
                            <FormInput
                              name="txtPhone"
                              label={phoneLabel}
                              margin="m-0"
                              editMode
                              defaultValue={requesterType === 'Supplier' ? phoneNumber : branchBusPhone}
                              placeholder="Phone Number"
                              readOnly={requesterType !== 'Supplier'}
                              onChange={setSupplierPhone}
                              disabled={userRole !== 'CT'}
                            />
                          </Col>
                        </Row>
                      </Col>

                      <Col sm={20} className="px-10">
                        <Card title="Pickup" headStyle={{ textAlign: 'center' }} className="mb-4" bordered>
                          <Row gutter={15}>
                            <Col sm={16}>
                              <Row gutter={15} className="mb-5">
                                <Col sm={9}>
                                  <SecondaryLabel className="f-12 text-black">
                                    We need a trailer picked up:
                                  </SecondaryLabel>
                                </Col>

                                <Col sm={15}>
                                  <Row gutter={15}>
                                    <Col>
                                      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this */}
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="pickLoaded"
                                        checked={selectedTrailerPickValue === 'Loaded'}
                                        value="Loaded"
                                        id="pickLoaded"
                                        onClick={shouldToggleChecked}
                                        disabled={userRole !== 'CT'}
                                      />
                                      <SecondaryLabel className="f-12 text-black"> Loaded </SecondaryLabel>
                                    </Col>

                                    <Col>
                                      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this */}
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="pickEmpty"
                                        checked={selectedTrailerPickValue === 'Empty'}
                                        value="Empty"
                                        id="pickEmpty"
                                        onClick={shouldToggleChecked}
                                        disabled={userRole !== 'CT'}
                                      />
                                      <SecondaryLabel className="f-12 text-black"> Empty </SecondaryLabel>
                                    </Col>

                                    <Col>
                                      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this */}
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="pickNone"
                                        checked={selectedTrailerPickValue === 'None'}
                                        value="None"
                                        id="pickNone"
                                        onClick={shouldToggleChecked}
                                        disabled={userRole !== 'CT'}
                                      />
                                      <SecondaryLabel className="f-12 text-black"> None of the above </SecondaryLabel>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              <Row gutter={15}>
                                <Col sm={4} hidden={trlHidden}>
                                  <FormSelectBox
                                    label="Trailer Number"
                                    editMode
                                    name="selTrailerName"
                                    margin="m-0"
                                    options={trailerOptions}
                                    placeholder="Select Trailer"
                                    onChange={selectTrailerName}
                                    disabled={disableFlag || userRole !== 'CT'}
                                  />
                                </Col>
                                <Col sm={4}>
                                  <FormSelectBox
                                    editMode
                                    label="Trailer Size"
                                    name="trailerSize"
                                    margin="m-0"
                                    options={trailerSizeOptions}
                                    placeholder="Select Trailer Size"
                                    onChange={selectTrailerSize}
                                    defaultValue={pickupTrailerSize}
                                    disabled
                                  />
                                </Col>
                                <Col sm={4}>
                                  <FormDatePicker
                                    name="trailerDate"
                                    label={pickupDateLabel}
                                    margin="m-0"
                                    onChange={selectRequestDate}
                                    defaultData={trailerRequestDate && moment(trailerRequestDate)}
                                    disabled={userRole !== 'CT'}
                                  />
                                </Col>

                                <Col sm={4}>
                                  <FormSelectBox
                                    label={pickupTimeLabel}
                                    editMode
                                    name="selectPickupTime"
                                    margin="m-0"
                                    onChange={selectRequestTimeframe}
                                    placeholder={pickupTimeLabel}
                                    options={PICKUP_TIME_OPTIONS}
                                    disabled={userRole !== 'CT'}
                                  />
                                </Col>
                                <Col sm={4}>
                                  <FormSelectBox
                                    label="Pickup Location"
                                    editMode
                                    name="pickupLocation"
                                    margin="m-0"
                                    disabled
                                    options={partnerLocationOptions}
                                    placeholder="Pickup Location"
                                    defaultValue={stopDesc2}
                                  />
                                </Col>
                              </Row>
                            </Col>

                            {userRole === 'CT' && (
                              <>
                                <Col sm={4}>
                                  <FormSelectBox
                                    label="Traffic Coordinator"
                                    editMode
                                    name="TrafficCoord"
                                    margin="m-0"
                                    options={trafficCoordinatorOptions}
                                    placeholder="Select Traffic Coordinator"
                                    onChange={selectTrafficCoordinatorId}
                                    defaultValue={trafficCoordinatorID}
                                  />
                                </Col>
                                <Col sm={4}>
                                  <FormSelectBox
                                    label="Request Status"
                                    editMode
                                    name="selRequestStatus"
                                    margin="m-0"
                                    options={
                                      trailerRequestStatusDesc === 'Confirmation Pending'
                                        ? trailerRequestStatusOptions.filter(
                                            (val) => val.value !== 'SBMT' && val.value !== 'RECV',
                                          )
                                        : trailerRequestStatusOptions
                                    }
                                    placeholder="Select Trailer Request Status"
                                    onChange={selectTrailerRequestStatus}
                                    defaultValue={trailerRequestStatusDesc}
                                  />
                                </Col>
                              </>
                            )}
                          </Row>

                          {(isLoadedPickUp || isEmptyPickUp) && (
                            <Row gutter={15} className="mt-10">
                              <Col sm={18}>
                                <Row gutter={15}>
                                  <Col sm={4}>
                                    <FormSelectBox
                                      label="Commodity:"
                                      editMode
                                      name="selCommodity"
                                      margin="m-0"
                                      options={commodityOptions}
                                      placeholder="Commodity"
                                      onChange={selectCommodity}
                                      defaultValue={productTypeDesc}
                                      disabled={isEmptyPickUp || userRole !== 'CT'}
                                    />
                                  </Col>
                                  {isLoadedPickUp && (
                                    <>
                                      <Col sm={4}>
                                        <FormInput
                                          inputType="number"
                                          name="sealNumber"
                                          label="Seal Number"
                                          margin="m-0"
                                          editMode
                                          onChange={selectSealNumber}
                                          placeholder="Seal Number"
                                          disabled
                                        />
                                      </Col>

                                      {requesterType !== 'Supplier' && (
                                        <ProductTypes
                                          productType={productType}
                                          form={formUpdateTrailerRequest}
                                          commodityOptions={commodityOptions}
                                          tableData={tableData}
                                          setTableData={setTableData}
                                          productTypeName={productTypeName}
                                          trailerSizeOptions={trailerSizeOptions}
                                          setPercentage={setPercentage}
                                          isMixed={isMixed}
                                        />
                                      )}
                                    </>
                                  )}
                                </Row>
                              </Col>

                              {isLoadedPickUp && requesterType !== 'Supplier' && (
                                <Col sm={6}>
                                  <div className="progress-container">
                                    <div className="text-center" style={{ color: progressBarColor }}>
                                      {percentage.toFixed(1)}% utilized
                                    </div>
                                    <CustomProgress
                                      percent={percentage}
                                      size={[280, 25]}
                                      strokeLinecap="butt"
                                      strokeColor={progressBarColor}
                                      showInfo={false}
                                    />
                                  </div>
                                </Col>
                              )}
                            </Row>
                          )}
                        </Card>
                        <Card title="Delivery" headStyle={{ textAlign: 'center' }} className="mb-4" bordered>
                          <Row gutter={15} className="mt-10">
                            <Col sm={16}>
                              <Row gutter={15}>
                                <Col sm={9}>
                                  <SecondaryLabel className="f-12 text-black">
                                    {' '}
                                    We need a trailer delivered:{' '}
                                  </SecondaryLabel>
                                </Col>
                                <Col sm={15}>
                                  <Row gutter={15}>
                                    <Col>
                                      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this */}
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="deliveryLoaded"
                                        checked={selectedValue === 'Loaded'}
                                        value="Loaded"
                                        id="Loaded"
                                        onClick={selectDelivered}
                                        disabled={requestUserType === 'Supplier'}
                                      />
                                      <SecondaryLabel className="f-12 text-black"> Loaded </SecondaryLabel>
                                    </Col>
                                    <Col>
                                      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this */}
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="deliveryEmpty"
                                        id="Empty"
                                        checked={selectedValue === 'Empty'}
                                        value="Empty"
                                        onClick={selectDelivered}
                                        disabled={userRole !== 'CT'}
                                      />
                                      <SecondaryLabel className="f-12 text-black"> Empty </SecondaryLabel>
                                    </Col>

                                    <Col>
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="deliveryNone"
                                        checked={selectedValue === 'None'}
                                        value="None"
                                        onClick={selectDelivered}
                                        disabled={userRole !== 'CT'}
                                      />
                                      <SecondaryLabel className="f-12 text-black"> None of the above </SecondaryLabel>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row gutter={15} className="mt-5">
                                <Col sm={6}>
                                  <FormDatePicker
                                    label="Delivery Date"
                                    name="deliveryDate"
                                    margin="m-0"
                                    value={deliveryDate}
                                    onChange={selectDeliveryDate}
                                    defaultData={deliveryDate}
                                    allowClear={false}
                                    disabledTargetDate={getLocalDateTime()}
                                    disableFuture={false}
                                    disabled={userRole !== 'CT'}
                                  />
                                </Col>
                                <Col sm={6}>
                                  <SecondaryLabel className="f-12 text-black"> Delivery Time </SecondaryLabel>
                                  <FormSelectBox
                                    editMode
                                    className="mt-2 w-100"
                                    name="selectDeliveryTime"
                                    margin="m-0"
                                    value={deliveryTime}
                                    onChange={selectDeliveryTime}
                                    placeholder="Delivery Location"
                                    options={deliveryTimeOptions}
                                    disabled={userRole !== 'CT'}
                                  />
                                </Col>
                                <Col sm={6}>
                                  <FormSelectBox
                                    label="Delivery Location"
                                    editMode
                                    name="deliveryLocation"
                                    value={locationID}
                                    disabled
                                    margin="m-0"
                                    options={partnerLocationOptions}
                                    placeholder="Delivery Location"
                                    defaultValue={stopDesc2}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          {(isLoadedDelivered || isEmptyDelivered) && (
                            <Row gutter={15} className="mt-5">
                              <Col sm={18}>
                                <Row gutter={15} className="mb-2">
                                  <Col sm={6}>
                                    <FormSelectBox
                                      label="Commodity:"
                                      editMode
                                      name="selCommodity1"
                                      margin="m-0"
                                      options={commodityOptions}
                                      placeholder="Commodity"
                                      onChange={selectdeliveryCommodity}
                                      defaultValue={deliveryproductTypeDesc}
                                      disabled={userRole !== 'CT'}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )}
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </Paper>

                <div className="floating-table-overlay" hidden={hidden} />
                <div hidden={hidden} className="floating-table shadow-sm full-height-modal" style={{ width: '55%' }}>
                  <div className="popup-header d-flex justify-content-between p-2 text-white theme-color">
                    <div className="">
                      <span />
                    </div>
                    <div className="">
                      <Button onClick={closeModal}>
                        <i className="fas fa-times close-modal" />
                      </Button>
                    </div>
                  </div>
                  <div className="popup-body p-5">
                    <p className="h6">
                      {' '}
                      Before you submit your trailer request, please review the details below to ensure accuracy.
                    </p>
                    <div className="row g-0 mb-2 fs-6">
                      <div className="col-3 col-xs-12">
                        <label htmlFor="">-Trailer #: </label>
                      </div>
                      <div className="col-8 col-xs-12">
                        <span>{trailerName}</span>
                      </div>
                    </div>

                    <div className="row g-0 mb-2 fs-6">
                      <div className="col-3 col-xs-12">
                        <label htmlFor="">-Date Trailer Loaded: </label>
                      </div>
                      <div className="col-8 col-xs-12">
                        <span>{trailerRequestDate}</span>
                      </div>
                    </div>

                    <div className="row g-0 mb-2 fs-6">
                      <div className="col-3 col-xs-12">
                        <label htmlFor="">-Time Trailer Loaded:</label>
                      </div>
                      <div className="col-8 col-xs-12">
                        <span>{moment(trailerRequestDate).format('h:mm a')}</span>
                      </div>
                    </div>

                    <div className="text-center mt-5">
                      <button
                        type="button"
                        className="btn btn-dipblue me-5 cursor-pointer"
                        onClick={saveTrailerRequestData}
                      >
                        {' '}
                        Proceed{' '}
                      </button>
                      <button type="button" className="btn btn-dipblue cursor-pointer" onClick={closeModal}>
                        {' '}
                        Cancel{' '}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-4 mb-10">
                  <Paper className="w-50 mr-4">
                    <div className="card-header p-8">
                      <SecondaryLabel className="f-14 text-white"> Special Instructions </SecondaryLabel>
                    </div>

                    <div className="p-10">
                      {/* Configuration Section */}
                      <Row gutter={24} className="mb-10">
                        <Col sm={10}>
                          <div className="mb-6">
                            <Row gutter={24}>
                              <Col sm={8}>
                                <SecondaryLabel className="f-12 mb-5">Trailer Door Type:</SecondaryLabel>
                              </Col>
                              <Col sm={8}>
                                <div className="mb-2">
                                  {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this */}
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    checked={selectedTrailerDoorValue === 'Swingdoor'}
                                    name="trlSwingdoor"
                                    value="SWNGDR"
                                    id="Swingdoor"
                                    onClick={selectDoorType}
                                  />
                                  <SecondaryLabel className="f-12"> Swing door</SecondaryLabel>
                                </div>
                              </Col>
                              <Col sm={8}>
                                <div className="mb-2">
                                  {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this */}
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    checked={selectedTrailerDoorValue === 'RollUpdoor'}
                                    name="trlRollUpdoor"
                                    value="RLLUPDR"
                                    id="RollUpdoor"
                                    onClick={selectDoorType}
                                  />
                                  <SecondaryLabel className="f-12"> Roll door</SecondaryLabel>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        <Col sm={7}>
                          <FormTextArea
                            editMode
                            name="txtSpclInstruct"
                            margin="mb-14"
                            placeholder="Special Instructions"
                            enableAutoFocus={false}
                            rows={3}
                            value={specialInstruction}
                            defaultValue={specialInstruction}
                            onChange={selectSpecialInstruction}
                          />
                        </Col>
                      </Row>
                      <Row gutter={15}>
                        <Col sm={16}>
                          <div className="mb-6">
                            <Row gutter={24}>
                              <Col sm={6}>
                                <SecondaryLabel className="f-12 mb-5">Live Load / Unload:</SecondaryLabel>
                              </Col>
                              <Col sm={4}>
                                <div className="mb-2">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="rbLoad"
                                    checked={selectedLoadValue === 'Load'}
                                    value="Yes"
                                    onClick={selectLiveLoad}
                                  />
                                  <SecondaryLabel className="f-12"> Yes</SecondaryLabel>
                                </div>
                              </Col>
                              <Col sm={4}>
                                <div className="mb-2">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="rbUnload"
                                    checked={selectedLoadValue === 'UnLoad'}
                                    value="No"
                                    onClick={selectLiveLoad}
                                  />
                                  <SecondaryLabel className="f-12"> No</SecondaryLabel>
                                </div>
                              </Col>
                              <Col sm={10}>
                                {isLiveLoad && (
                                  <FormSelectBox
                                    label={
                                      <Tooltip title="Driver stays on site while loading/unloading 1-4 hours max.">
                                        Hours:
                                      </Tooltip>
                                    }
                                    editMode
                                    name="LiveLoadHours"
                                    margin="m-0"
                                    options={liveLoadHoursOptions}
                                    placeholder="Select Hours"
                                    onChange={setLiveLoadUnloadHour}
                                  />
                                )}
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Paper>

                  <Paper className="w-50">
                    <div className="card-header p-8">
                      <SecondaryLabel className="f-14 text-white">Visible to admins only</SecondaryLabel>
                    </div>

                    <div className="p-10">
                      {/* Scheduling Section */}
                      {
                        <>
                          <Row gutter={24} className="mb-8">
                            <Col sm={6}>
                              <FormDatePicker
                                label="Submitted Date"
                                name="submittedDate"
                                margin="m-0"
                                defaultData={getLocalDateTime()}
                                disabled
                              />
                            </Col>
                            <Col sm={6}>
                              <FormDatePicker
                                label="Expected delivery Date"
                                name="expDeliveryDate"
                                margin="m-0"
                                onChange={handleExpDeliveryDateChange}
                                allowClear={false}
                                disabledTargetDate={getLocalDateTime()}
                                disableFuture={false}
                                placeholder="Expected delivery Date"
                                value={expDeliveryDate}
                              />
                            </Col>
                            <Col sm={6}>
                              <FormSelectBox
                                label="Expected Delivery Time"
                                editMode
                                name="expDeliveryTime"
                                margin="m-0"
                                onChange={handleExpDeliveryTimeChange}
                                placeholder="Expected Delivery Time"
                                options={deliveryTimeOptions}
                                value={expDeliveryTime}
                              />
                            </Col>
                            <Col sm={6} className="mt-10">
                              <TMSFiledCard containerClass="mb-10" title="Matches DDP">
                                <ToggleSwitch
                                  checkedChildren="Yes"
                                  name="matchesDDP"
                                  unCheckedChildren="NO"
                                  onChange={handleMatchesDDPChange}
                                  checked={matchesDDP}
                                />
                              </TMSFiledCard>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={7}>
                              <FormTextArea
                                editMode
                                name="comments"
                                margin="mb-14"
                                placeholder="Comments"
                                enableAutoFocus={false}
                                rows={3}
                                onChange={handleCommentsChange}
                              />
                            </Col>
                          </Row>
                        </>
                      }
                    </div>
                  </Paper>
                </div>
                <div className="text-center mb-10">
                  <button
                    type="button"
                    className="btn btn-dipblue mr-5 cursor-pointer"
                    onClick={() => navigate(APP_ROUTES.SAVERS)}
                  >
                    Exit
                  </button>
                  {trailerRequestStatusID === 'RECV' && userRole === 'CT' && (
                    <button
                      type="button"
                      className="btn btn-dipblue mr-5 cursor-pointer"
                      onClick={() => onProceed('proceed')}
                      hidden={disableFlag}
                    >
                      Proceed
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-dipblue cursor-pointer"
                    onClick={() => onProceed('save')}
                    hidden={disableFlag}
                  >
                    Save Changes
                  </button>
                </div>
                <AlertModal
                  title="Alert"
                  open={alertOpen}
                  description={alertMessage}
                  onOk={onAlertConfirm}
                  onClose={onAlertConfirm}
                />
                <WarningModal
                  alertTitle="Warning"
                  open={warningModal}
                  description={warning}
                  onClose={() => setWarningModal(false)}
                  onOk={() => setWarningModal(false)}
                />
                <ConfirmationModal
                  title="Alert"
                  open={newSuccessAlert}
                  description={successMessage}
                  onOk={saveTrailerRequestData}
                  onClose={onConfirmFunc}
                  onCancel={onConfirmFunc}
                  cancelButton={false}
                  okButtonVariant="error"
                />
              </div>
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
}
